module.exports = __webpack_public_path__ + "static/img/bjtt.92a11c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjtt.png
// module id = PBZK
// module chunks = 0